// Keep Talent sign-in returns within authenticated Talent pages. Never accept
// a protocol-relative, external, backslash or authentication-page destination.
export function resolveTalentReturnTo(search = "") {
  const requested = new URLSearchParams(search).get("returnTo");
  if (!requested || !/^\/talent(?:[/?#]|$)/.test(requested)
    || requested.includes("\\") || /[\u0000-\u001f\u007f]/.test(requested)) {
    return "/talent";
  }
  const pathname = requested.split(/[?#]/, 1)[0].toLowerCase();
  if (/^\/talent\/(?:login|change-password|reset-password|forgot-password|verify-account)(?:\/|$)/.test(pathname)) {
    return "/talent";
  }
  return requested;
}
